import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Importar traducciones
import esCommon from '@/data/locales/es/common.json';
import enCommon from '@/data/locales/en/common.json';
import ptCommon from '@/data/locales/pt/common.json';

const resources = {
  es: {
    common: esCommon,
  },
  en: {
    common: enCommon,
  },
  pt: {
    common: ptCommon,
  },
};

// Configuración de detección de idioma
const detectionOptions = {
  order: ['localStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
  lookupLocalStorage: 'preferredLanguage',
  caches: ['localStorage'],
  excludeCacheFor: ['cimode'],
  checkWhitelist: true
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'es',
    defaultNS: 'common',
    
    detection: detectionOptions,

    interpolation: {
      escapeValue: false,
    },

    // Configuración de desarrollo
    debug: import.meta.env.DEV,
    
    // Configuración de carga
    load: 'languageOnly',
    preload: ['es', 'en', 'pt'],
    
    // Configuración de namespace
    ns: ['common'],
    
    // Configuración de plurales
    pluralSeparator: '_',
    contextSeparator: '_',
    
    // Configuración de reactividad
    react: {
      useSuspense: false,
      bindI18n: 'languageChanged loaded',
      bindI18nStore: 'added removed',
      transEmptyNodeValue: '',
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p'],
    },
  });

export default i18n;

// Función para agregar nuevos idiomas dinámicamente
export const addLanguageResources = (language: string, namespace: string, resources: any) => {
  i18n.addResourceBundle(language, namespace, resources, true, true);
};

// Función para verificar si un idioma está cargado
export const isLanguageLoaded = (language: string) => {
  return i18n.hasResourceBundle(language, 'common');
};

// Función para cargar idiomas bajo demanda
export const loadLanguage = async (language: string) => {
  if (!isLanguageLoaded(language)) {
    try {
      const resources = await import(`@/data/locales/${language}/common.json`);
      addLanguageResources(language, 'common', resources.default);
      return true;
    } catch (error) {
      console.warn(`Failed to load language ${language}:`, error);
      return false;
    }
  }
  return true;
};